// This file is auto-generated from registry.toml using Tera.
// Do not edit directly. Regenerate via Rust build step.

import type { FormatDescriptor } from "./bindings/FormatDescriptor";

export const registryMetadata: { [key: number]: FormatDescriptor } = {
1: {
line_length: 28,
sampling_interval_seconds: 3600,
fields: [
{
name: "Timestamp",
type: "U64",
description: "Time & date values recorded",
unit: "",
label: "Time",
group: "",
visible: true,
role: "timestamp"

},
{
name: "BattV_Min",
type: "FP2",
description: "Battery voltage (minimum)",
unit: "V",
label: "Battery Volt.",
group: "",
visible: true,
role: ""

},
{
name: "PTemp_C_Min",
type: "FP2",
description: "Panel temperature of logger (minimum)",
unit: "°C",
label: "Panel Temp.",
group: "",
visible: true,
role: ""

},
{
name: "AirTC_Avg",
type: "FP2",
description: "Air temperature (average)",
unit: "°C",
label: "Air Temp.",
group: "",
visible: true,
role: ""

},
{
name: "RH_Avg",
type: "FP2",
description: "Relative humidity (average)",
unit: "%",
label: "Humidity",
group: "",
visible: true,
role: ""

},
{
name: "SW_in_Avg",
type: "FP2",
description: "Shortwave radiation (average)",
unit: "W/m²",
label: "Solar Rad.",
group: "",
visible: true,
role: ""

},
{
name: "Apogee_barometer",
type: "IEEE4",
description: "Barometric pressure",
unit: "hPa",
label: "Pressure",
group: "",
visible: true,
role: ""

},
{
name: "WS_ms_S_WVT",
type: "FP2",
description: "Wind speed (average)",
unit: "m/s",
label: "Wind Speed",
group: "",
visible: true,
role: "wind_speed"

},
{
name: "WindDir_D1_WVT",
type: "FP2",
description: "Wind direction (vector average)",
unit: "degrees",
label: "Wind Dir.",
group: "",
visible: true,
role: "wind_direction"

},
{
name: "WindDir_SD1_WVT",
type: "FP2",
description: "Wind direction (standard deviation)",
unit: "degrees",
label: "Wind Dir. StdDev",
group: "",
visible: true,
role: "wind_stdev"

}
]
},
2: {
line_length: 72,
sampling_interval_seconds: 3600,
fields: [
{
name: "Timestamp",
type: "U64",
description: "Time & date values recorded",
unit: "",
label: "Time",
group: "",
visible: true,
role: "timestamp"

},
{
name: "BattV",
type: "FP2",
description: "Battery voltage",
unit: "V",
label: "Battery Volt.",
group: "",
visible: true,
role: ""

},
{
name: "PTemp_C",
type: "FP2",
description: "Panel temperature of logger",
unit: "°C",
label: "Panel Temp.",
group: "",
visible: true,
role: ""

},
{
name: "TRHData_1",
type: "FP2",
description: "Air temperature",
unit: "°C",
label: "Air Temp",
group: "",
visible: true,
role: ""

},
{
name: "TRHData_2",
type: "FP2",
description: "Relative humidity",
unit: "%",
label: "Humidity",
group: "",
visible: true,
role: ""

},
{
name: "Net_rad_1",
type: "FP2",
description: "Incoming short wave radiation",
unit: "W/m²",
label: "SW In",
group: "",
visible: false,
role: ""

},
{
name: "Net_rad_2",
type: "FP2",
description: "Outgoing short wave radiation",
unit: "W/m²",
label: "SW Out",
group: "",
visible: false,
role: ""

},
{
name: "Net_rad_3",
type: "FP2",
description: "Incoming long wave radiation",
unit: "W/m²",
label: "LW In",
group: "",
visible: false,
role: ""

},
{
name: "Net_rad_4",
type: "FP2",
description: "Outgoing long wave radiation",
unit: "W/m²",
label: "LW Out",
group: "",
visible: false,
role: ""

},
{
name: "T109_C_1",
type: "FP2",
description: "Soil temperature (sensor 1)",
unit: "°C",
label: "Soil Temp.",
group: "Soil Temperature",
visible: true,
role: "soil_temperature"

},
{
name: "T109_C_2",
type: "FP2",
description: "Soil temperature (sensor 2)",
unit: "°C",
label: "Soil Temp.",
group: "Soil Temperature",
visible: true,
role: "soil_temperature"

},
{
name: "T109_C_3",
type: "FP2",
description: "Soil temperature (sensor 3)",
unit: "°C",
label: "Soil Temp.",
group: "Soil Temperature",
visible: true,
role: "soil_temperature"

},
{
name: "T109_C_4",
type: "FP2",
description: "Soil temperature (sensor 4)",
unit: "°C",
label: "Soil Temp.",
group: "Soil Temperature",
visible: true,
role: "soil_temperature"

},
{
name: "T109_C_5",
type: "FP2",
description: "Soil temperature (sensor 5)",
unit: "°C",
label: "Soil Temp.",
group: "Soil Temperature",
visible: true,
role: "soil_temperature"

},
{
name: "T109_C_6",
type: "FP2",
description: "Soil temperature (sensor 6)",
unit: "°C",
label: "Soil Temp.",
group: "Soil Temperature",
visible: true,
role: "soil_temperature"

},
{
name: "T109_C_7",
type: "FP2",
description: "Soil temperature (sensor 7)",
unit: "°C",
label: "Soil Temp.",
group: "Soil Temperature",
visible: true,
role: "soil_temperature"

},
{
name: "T109_C_8",
type: "FP2",
description: "Soil temperature (sensor 8)",
unit: "°C",
label: "Soil Temp.",
group: "Soil Temperature",
visible: true,
role: "soil_temperature"

},
{
name: "T109_C_9",
type: "FP2",
description: "Soil temperature (sensor 9)",
unit: "°C",
label: "Soil Temp.",
group: "Soil Temperature",
visible: true,
role: "soil_temperature"

},
{
name: "T109_C_10",
type: "FP2",
description: "Soil temperature (sensor 10)",
unit: "°C",
label: "Soil Temp.",
group: "Soil Temperature",
visible: true,
role: "soil_temperature"

},
{
name: "VWC",
type: "FP2",
description: "Soil volumetric water content (HygroVUE #1)",
unit: "m³/m³",
label: "Water Cont. #1",
group: "",
visible: true,
role: ""

},
{
name: "EC",
type: "FP2",
description: "Soil conductivity (HygroVUE #1)",
unit: "dS/m",
label: "Conductivity #1",
group: "",
visible: false,
role: ""

},
{
name: "T",
type: "FP2",
description: "Soil temperature (HygroVUE #1)",
unit: "°C",
label: "Soil Temp #1",
group: "",
visible: false,
role: ""

},
{
name: "P",
type: "FP2",
description: "Bulk dielectric permittivity (HygroVUE #1)",
unit: "unitless",
label: "Permittivity #1",
group: "",
visible: false,
role: ""

},
{
name: "PA",
type: "FP2",
description: "Period average (HygroVUE #1)",
unit: "nSec",
label: "Period Avg #1",
group: "",
visible: false,
role: ""

},
{
name: "VR",
type: "FP2",
description: "Voltage ratio (HygroVUE #1)",
unit: "unitless",
label: "Voltage Ratio #1",
group: "",
visible: false,
role: ""

},
{
name: "VWC_2",
type: "FP2",
description: "Soil volumetric water content (HygroVUE #2)",
unit: "m³/m³",
label: "Water Cont. #2",
group: "",
visible: true,
role: ""

},
{
name: "EC_2",
type: "FP2",
description: "Soil conductivity (HygroVUE #2)",
unit: "dS/m",
label: "Conductivity #2",
group: "",
visible: false,
role: ""

},
{
name: "T_2",
type: "FP2",
description: "Soil temperature (HygroVUE #2)",
unit: "°C",
label: "Soil Temp #2",
group: "",
visible: false,
role: ""

},
{
name: "P_2",
type: "FP2",
description: "Bulk dielectric permittivity (HygroVUE #2)",
unit: "unitless",
label: "Permittivity #2",
group: "",
visible: false,
role: ""

},
{
name: "PA_2",
type: "FP2",
description: "Period average (HygroVUE #2)",
unit: "nSec",
label: "Period Avg #2",
group: "",
visible: false,
role: ""

},
{
name: "VR_2",
type: "FP2",
description: "Voltage ratio (HygroVUE #2)",
unit: "unitless",
label: "Volt. Ratio #2",
group: "",
visible: false,
role: ""

},
{
name: "Davis_winspd_S_WVT",
type: "FP2",
description: "Average wind speed",
unit: "m/s",
label: "Wind Speed",
group: "",
visible: true,
role: "wind_speed"

},
{
name: "Wind_dir_D1_WVT",
type: "FP2",
description: "Vector average wind direction",
unit: "degrees",
label: "Wind Dir.",
group: "",
visible: true,
role: "wind_direction"

}
]
},
3: {
line_length: 64,
sampling_interval_seconds: 3600,
fields: [
{
name: "Timestamp",
type: "U64",
description: "Time & date values recorded",
unit: "",
label: "Time",
group: "",
visible: true,
role: "timestamp"

},
{
name: "BattV",
type: "FP2",
description: "Battery voltage",
unit: "V",
label: "Battery Volt.",
group: "",
visible: true,
role: ""

},
{
name: "PTemp_C",
type: "FP2",
description: "Panel temperature of logger",
unit: "°C",
label: "Panel Temp.",
group: "",
visible: true,
role: ""

},
{
name: "TRHData_1",
type: "FP2",
description: "Air temperature",
unit: "°C",
label: "Air Temp.",
group: "",
visible: true,
role: ""

},
{
name: "TRHData_2",
type: "FP2",
description: "Relative humidity",
unit: "%",
label: "Humidity",
group: "",
visible: true,
role: ""

},
{
name: "T109_C_1",
type: "FP2",
description: "Soil temperature (sensor 1)",
unit: "°C",
label: "Soil Temp.",
group: "Soil Temperature",
visible: true,
role: "soil_temperature"

},
{
name: "T109_C_2",
type: "FP2",
description: "Soil temperature (sensor 2)",
unit: "°C",
label: "Soil Temp.",
group: "Soil Temperature",
visible: true,
role: "soil_temperature"

},
{
name: "T109_C_3",
type: "FP2",
description: "Soil temperature (sensor 3)",
unit: "°C",
label: "Soil Temp.",
group: "Soil Temperature",
visible: true,
role: "soil_temperature"

},
{
name: "T109_C_4",
type: "FP2",
description: "Soil temperature (sensor 4)",
unit: "°C",
label: "Soil Temp.",
group: "Soil Temperature",
visible: true,
role: "soil_temperature"

},
{
name: "T109_C_5",
type: "FP2",
description: "Soil temperature (sensor 5)",
unit: "°C",
label: "Soil Temp.",
group: "Soil Temperature",
visible: true,
role: "soil_temperature"

},
{
name: "T109_C_6",
type: "FP2",
description: "Soil temperature (sensor 6)",
unit: "°C",
label: "Soil Temp.",
group: "Soil Temperature",
visible: true,
role: "soil_temperature"

},
{
name: "T109_C_7",
type: "FP2",
description: "Soil temperature (sensor 7)",
unit: "°C",
label: "Soil Temp.",
group: "Soil Temperature",
visible: true,
role: "soil_temperature"

},
{
name: "T109_C_8",
type: "FP2",
description: "Soil temperature (sensor 8)",
unit: "°C",
label: "Soil Temp.",
group: "Soil Temperature",
visible: true,
role: "soil_temperature"

},
{
name: "T109_C_9",
type: "FP2",
description: "Soil temperature (sensor 9)",
unit: "°C",
label: "Soil Temp.",
group: "Soil Temperature",
visible: true,
role: "soil_temperature"

},
{
name: "T109_C_10",
type: "FP2",
description: "Soil temperature (sensor 10)",
unit: "°C",
label: "Soil Temp.",
group: "Soil Temperature",
visible: true,
role: "soil_temperature"

},
{
name: "VWC",
type: "FP2",
description: "Soil volumetric water content (HygroVUE #1)",
unit: "m³/m³",
label: "Water Content #1",
group: "",
visible: true,
role: ""

},
{
name: "EC",
type: "FP2",
description: "Soil conductivity (HygroVUE #1)",
unit: "dS/m",
label: "Conductivity #1",
group: "",
visible: false,
role: ""

},
{
name: "T",
type: "FP2",
description: "Soil temperature (HygroVUE #1)",
unit: "°C",
label: "Soil Temp. #1",
group: "",
visible: false,
role: ""

},
{
name: "P",
type: "FP2",
description: "Bulk dielectric permittivity (HygroVUE #1)",
unit: "unitless",
label: "Permittivity #1",
group: "",
visible: false,
role: ""

},
{
name: "PA",
type: "FP2",
description: "Period average (HygroVUE #1)",
unit: "nSec",
label: "Period Avg #1",
group: "",
visible: false,
role: ""

},
{
name: "VR",
type: "FP2",
description: "Voltage ratio (HygroVUE #1)",
unit: "unitless",
label: "Volt. Ratio #1",
group: "",
visible: false,
role: ""

},
{
name: "VWC_2",
type: "FP2",
description: "Soil volumetric water content (HygroVUE #2)",
unit: "m³/m³",
label: "Water Content #2",
group: "",
visible: true,
role: ""

},
{
name: "EC_2",
type: "FP2",
description: "Soil conductivity (HygroVUE #2)",
unit: "dS/m",
label: "Conductivity #2",
group: "",
visible: false,
role: ""

},
{
name: "T_2",
type: "FP2",
description: "Soil temperature (HygroVUE #2)",
unit: "°C",
label: "Soil Temp. #2",
group: "",
visible: false,
role: ""

},
{
name: "P_2",
type: "FP2",
description: "Bulk dielectric permittivity (HygroVUE #2)",
unit: "unitless",
label: "Permittivity #2",
group: "",
visible: false,
role: ""

},
{
name: "PA_2",
type: "FP2",
description: "Period average (HygroVUE #2)",
unit: "nSec",
label: "Period Avg #2",
group: "",
visible: false,
role: ""

},
{
name: "VR_2",
type: "FP2",
description: "Voltage ratio (HygroVUE #2)",
unit: "unitless",
label: "Volt. Ratio #2",
group: "",
visible: false,
role: ""

},
{
name: "Davis_winspd_S_WVT",
type: "FP2",
description: "Average wind speed",
unit: "m/s",
label: "Wind Speed",
group: "",
visible: true,
role: "wind_speed"

},
{
name: "Wind_dir_D1_WVT",
type: "FP2",
description: "Vector average wind direction",
unit: "degrees",
label: "Wind Dir",
group: "",
visible: true,
role: "wind_direction"

}
]
},
4: {
line_length: 0,
sampling_interval_seconds: 600,
fields: [
{
name: "Timestamp",
type: "U64",
description: "Time & date values recorded",
unit: "",
label: "Time",
group: "",
visible: true,
role: "timestamp"

},
{
name: "BattV_Avg",
type: "FP2",
description: "Battery voltage (average)",
unit: "V",
label: "Battery Volt.",
group: "",
visible: true,
role: ""

},
{
name: "PTemp_C_Avg",
type: "FP2",
description: "Panel temperature (average)",
unit: "°C",
label: "Panel Temp.",
group: "",
visible: true,
role: ""

},
{
name: "IncomingSW_Avg",
type: "FP2",
description: "Incoming shortwave radiation",
unit: "W/m²",
label: "SW In",
group: "Shortwave Radiation",
visible: true,
role: ""

},
{
name: "OutgoingSW_Avg",
type: "FP2",
description: "Outgoing shortwave radiation",
unit: "W/m²",
label: "SW Out",
group: "Shortwave Radiation",
visible: true,
role: ""

},
{
name: "T107_C_airT_50cm_Avg",
type: "FP2",
description: "Air temp. at 50 cm",
unit: "°C",
label: "Air Temp",
group: "Air Temperature",
visible: true,
role: ""

},
{
name: "SoilTemp_C_2cm_Avg",
type: "FP2",
description: "Soil temp. at 2 cm",
unit: "°C",
label: "Soil Temp",
group: "Soil Temperature",
visible: true,
role: "soil_temperature"

},
{
name: "soil_Temp_C_30cm_Avg",
type: "FP2",
description: "Soil temp. at 30 cm",
unit: "°C",
label: "Soil Temp",
group: "Soil Temperature",
visible: true,
role: "soil_temperature"

},
{
name: "AirPress_mbar",
type: "IEEE4",
description: "Air pressure",
unit: "mbar",
label: "Pressure",
group: "",
visible: false,
role: ""

},
{
name: "Upper_AirTemp_Avg",
type: "FP2",
description: "Air temp. at 3 m",
unit: "°C",
label: "Air Temp",
group: "Air Temperature",
visible: true,
role: ""

},
{
name: "RH_Avg",
type: "FP2",
description: "Relative humidity",
unit: "%",
label: "Humidity",
group: "",
visible: true,
role: ""

},
{
name: "Rain_mm_Tot",
type: "FP2",
description: "Rainfall total",
unit: "mm",
label: "Rainfall",
group: "",
visible: true,
role: "rain_total"

},
{
name: "Rain_gauge_Temp_C_Avg",
type: "FP2",
description: "Rain gauge temperature",
unit: "°C",
label: "Rain Gauge Temp.",
group: "",
visible: true,
role: ""

},
{
name: "Wind_speed_WVc_1",
type: "FP2",
description: "Wind speed",
unit: "m/s",
label: "Wind Speed",
group: "",
visible: true,
role: "wind_speed"

},
{
name: "Wind_direction_WVc_2",
type: "FP2",
description: "Wind direction",
unit: "degrees",
label: "Wind Dir.",
group: "",
visible: true,
role: "wind_direction"

}
]
},
99: {
line_length: 5,
sampling_interval_seconds: null,
fields: [
{
name: "TestString",
type: "BYTES",
description: null,
unit: null,
label: "",
group: "",
visible: true,
role: ""

}
]
}
};